<template>
  <div
    class="row items-start q-mb-md"
    :class="compactView ? 'q-col-gutter-sm q-mt-xs' : 'q-col-gutter-md'"
  >
    <model-form-select
      field="config.widgetPosition"
      value-type="String"
      :class="compactView ? 'col' : 'col-3'"
      label="Banner Position"
      :options="positionOptions"
      map-options
      emit-value
    />
    <model-form-toggle
      field="config.isSticky"
      value-type="Boolean"
      :class="compactView ? 'col-12 q-pb-xs' : 'col-3'"
      label="Sticky"
    >
      <q-tooltip>
        Stays visible at the top of the page when scrolling. Has no effect on preview below.
      </q-tooltip>
    </model-form-toggle>

    <model-form-toggle
      field="config.denseLayout"
      value-type="Boolean"
      :class="compactView ? 'col-12 q-pb-xs' : 'col-3'"
      label="Dense Layout"
    />
    <model-form-toggle
      field="config.animated"
      value-type="Boolean"
      :class="compactView ? 'col-12 q-pb-xs' : 'col-3'"
      label="Animated"
    />
  </div>

  <global-widget-block-table
    class="q-mb-md"
    :global-widget="globalWidget"
    :type="GLOBAL_WIDGET_TYPES.BANNER"
    compact-view
  />
</template>

<script>
import GlobalWidget, { BANNER_POSITION_OPTIONS, GLOBAL_WIDGET_TYPES } from 'src/models/global-widget/GlobalWidget'
import GlobalWidgetBlockTable from 'src/modules/admin/global-widget/GlobalWidgetBlockTable'

export default {
  name: 'GlobalWidgetBannerEditor',
  components: {
    GlobalWidgetBlockTable
  },
  props: {
    globalWidget: {
      type: GlobalWidget,
      required: true
    },
    compactView: {
      type: Boolean,
      default: false
    }
  },
  models: {
    movies: {
      fields: ['id', 'name'],
      variables () {
        return {
          searchString: this.movieSearchString,
          orderBy: 'createdAt',
          descending: true,
          limit: 10
        }
      }
    },
    pages: {
      fields: ['id', 'slug', 'title'],
      variables () {
        return {
          searchString: this.pageSearchString,
          limit: 10
        }
      }
    }
  },
  data () {
    return {
      movieSearchString: '',
      pageSearchString: ''
    }
  },
  created () {
    _.extend(this, {
      GLOBAL_WIDGET_TYPES,
      positionOptions: this.$mh.asOptions(BANNER_POSITION_OPTIONS.ALL)
    })
  },
  mounted () {
    this.$mh.setCustomPageStyles(this.globalWidget.transformedStyles)
  },
  unmounted () {
    this.$mh.setCustomPageStyles(null)
  }
}
</script>
